import Button from '@porterin/component-library/src/base-components/button/Button';
import { useLocation } from '@porterin/component-library/src/location-accuracy//contexts/LocationContext';
import { MapWaypointCityLabelCmp } from '@porterin/component-library/src/location-accuracy/components/MapWaypointCityLabelCmp';
import React from 'react';

export const MapWaypointHeaderCmp: React.FC = () => {
  const { updateStep } = useLocation();
  const onAddressChange = () => {
    updateStep('SelectLocation');
  };

  return (
    <div className="flex items-center justify-between">
      <MapWaypointCityLabelCmp />
      <div className="max-w-[5.6rem]">
        <Button
          type="button"
          data-testid="cancel-location-address"
          identifiers={{ id: 'cancel-location-address' }}
          onClick={onAddressChange}
          className="
              w-full p-4
              bg-white text-[#0a57ff]
              font-semibold text-[1.4rem] leading-[2rem]
              active:bg-[#e5ecff]
              disabled:border-[#d0d4d8] disabled:text-[#9499a3]
            "
        >
          Change
        </Button>
      </div>
    </div>
  );
};
